"use strict";
const apiUrl = "https://www.shopify.thinksurfmedia.com"
document.getElementById('account-details').addEventListener('click',()=>{
    document.getElementById('account-popup').style.display = 'flex';
    document.getElementById('account-popup').style.opacity = '100%'
})

document.getElementById('account-popup-close').addEventListener('click',()=>{
    document.getElementById('account-popup').style.opacity = '0%'
    setTimeout(()=>{
        document.getElementById('account-popup').style.display = 'none';
    },600)
})

document.getElementById('refund-popup-close').addEventListener('click',()=>{
    document.getElementById('refund-popup').style.opacity = '0%'
    setTimeout(()=>{
        document.getElementById('refund-popup').style.display = 'none';
    },600)
})

document.querySelectorAll('[data-cancel]').forEach(button=>{
    button.addEventListener('click',async (e)=>{
        e.target.disabled = true;
        e.target.innerText = 'Please Wait...';
        const res = await fetch(apiUrl+"/order/"+e.target.dataset.cancel+"/cancel?storeName=vivabaazar")
        if(res.status == 200){
            location.reload()
        } else {
            alert("Something went wrong, please try after some time")
        }
    })
})

document.querySelectorAll('[data-refund]').forEach(button=>{
    button.addEventListener('click',async (e)=>{
        e.target.disabled = true;
        e.target.innerText = 'Please Wait...';
        const res = await fetch(apiUrl+"/order/"+e.target.dataset.refund+"/refund?storeName=vivabaazar")
        const data = await res.json()
        console.log(data)
        document.getElementById('refund-popup').style.display = 'flex';
        document.getElementById('refund-popup').style.opacity = '100%'
        document.getElementById('get-coupon').dataset.refund = e.target.dataset.refund;
        document.querySelectorAll('.refund-amount').forEach(e=>{
            e.innerText = data.transactions[0].amount
        })
    })
})

document.getElementById('get-coupon').addEventListener('click',async (e)=>{
    e.target.disabled = true;
    e.target.innerText = 'Please Wait...';
    const res = await fetch(apiUrl+"/order/"+e.target.dataset.refund+"/refund/complete?storeName=vivabaazar");
    console.log(apiUrl+"/order/"+e.target.dataset.refund+"/refund/complete")
    if(res.status == 200){
        location.reload()
    } else {
        alert("Something went wrong, please try after some time")
    }
})




